import React, { Component } from "react";
import styles from "./Percentage.local.scss";
import { IconContext } from "react-icons";
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
import { abbreviateNumber } from "Utils";
import NumberFormat from "react-number-format";

class Percentage extends Component {
  render() {
    let { percentage, comparison, hideIcon, showSign } = this.props;

    if (!comparison) {
      comparison = percentage => percentage >= 0;
    }
    let comp = comparison(percentage);
    if (!percentage) {
      return <span className={styles.percentage__na}>N/A</span>;
    }
    if (comp) {
      return (
        <span
          className={
            comp ? styles.percentage__positive : styles.percentage__negative
          }
        >
          {/*&nbsp;*/}
          {!hideIcon && (
            <span className="">
              <IconContext.Provider
                value={{ style: { verticalAlign: "sub", marginBottom: 1 } }}
              >
                <TiArrowSortedUp />
              </IconContext.Provider>
            </span>
          )}
          <span>
            <NumberFormat
              value={
                Math.abs(percentage).toString().length > 7
                  ? abbreviateNumber(Math.abs(percentage), 0)
                  : Math.abs(percentage)
              }
              displayType={"text"}
              thousandSeparator={"."}
              decimalSeparator={","}
              suffix={" %"}
              prefix={showSign ? (percentage > 0 ? "+" : "-") : ""}
            />
            {/*       {(showSign ? (percentage > 0 ? "+" : "-") : "") +
              (Math.abs(percentage).toString().length > 7
                ? abbreviateNumber(Math.abs(percentage), 0)
                : Math.abs(percentage))}%*/}
          </span>
        </span>
      );
    } else {
      return (
        <span
          className={
            comparison(percentage)
              ? styles.percentage__positive
              : styles.percentage__negative
          }
        >
          {/*&nbsp;*/}
          {!hideIcon && (
            <span className="">
              <IconContext.Provider
                value={{ style: { verticalAlign: "sub", marginBottom: 1 } }}
              >
                <TiArrowSortedDown />
              </IconContext.Provider>
            </span>
          )}{" "}
          <NumberFormat
            value={
              Math.abs(percentage).toString().length > 7
                ? abbreviateNumber(Math.abs(percentage), 0)
                : Math.abs(percentage)
            }
            displayType={"text"}
            thousandSeparator={"."}
            decimalSeparator={","}
            suffix={" %"}
            prefix={showSign ? (percentage > 0 ? "+" : "-") : ""}
          />
          {/* {(showSign ? (percentage > 0 ? "+" : "-") : "") +
            (Math.abs(percentage).toString().length > 7
              ? abbreviateNumber(Math.abs(percentage), 0)
              : Math.abs(percentage))}%*/}
        </span>
      );
    }
  }
}

export default Percentage;



// WEBPACK FOOTER //
// ./src/components/Common/Percentage/Percentage.js